// extracted by mini-css-extract-plugin
export default {"contenedor":"footer_contenedor__0UHxD"};